<script setup lang="ts">
import { RouterLink } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import Image from '@uiKit/elements/Image.vue'
import Text from '@uiKit/elements/Text.vue'
import { routes } from '@app/router/routes'

import logo from '@assets/images/logo.svg'
import slicealText from '@assets/images/sliceal-text.svg'
</script>

<template>
  <Box is="header" class="auth-top-header">
    <Box class="auth-top-header__brand" align="center">
      <Image :src="logo" width="35" height="35" class="auth-top-header__logo-icon" />
      <Image :src="slicealText" width="140" height="26" class="auth-top-header__logo-text" />
    </Box>

    <RouterLink :to="routes.HELP" class="auth-top-header__help">
      <Text
        is="span"
        type="body"
        weight="semibold"
        color="default"
        class="auth-top-header__help-text"
      >
        Need Help?
      </Text>
    </RouterLink>
  </Box>
</template>

<style scoped>
.auth-top-header {
  display: flex;
  align-items: center;
  /* Brand left, "Need Help?" right — the board's row is justify-between. */
  justify-content: space-between;
  gap: 1rem;
  /* Height tracks the viewport height (see the density scale on
     `.signup-shell`), so the brand row gives space back on a short laptop
     instead of eating 80px of the form's budget. The mark itself is
     untouched — only the band around it shrinks. */
  height: var(--auth-header-h, 80px);
  /* 2.5rem matches the sign-up shell's 40px gutter from the design board; the
     1.5rem page-gutter scale applies to app pages, not this auth shell. */
  padding: 0 2.5rem;
  border-bottom: 1px solid var(--p-content-border-color);
  flex-shrink: 0;
  box-sizing: border-box;
}

/* The monogram and wordmark must read as one mark — the gap lives here only,
   never also as a margin on the wordmark (see ux-principles logo-cohesion seam). */
.auth-top-header__brand {
  gap: 0.5rem;
}

.auth-top-header__logo-icon,
.auth-top-header__logo-text {
  object-fit: contain;
}

.auth-top-header__help {
  flex-shrink: 0;
  text-decoration: none;
  border-radius: var(--p-border-radius-sm);
}

.auth-top-header__help:hover {
  text-decoration: underline;
}

.auth-top-header__help:focus-visible {
  outline: 2px solid var(--p-primary-600);
  outline-offset: 2px;
}

/* Board: 14/20 — `body`'s 1.6 line-height would make the line box 22px. */
.auth-top-header__help-text {
  line-height: 20px;
  white-space: nowrap;
}

@media (max-width: 992px) {
  .auth-top-header {
    padding: env(safe-area-inset-top, 0) 1rem 0;
    height: calc(var(--auth-header-h, 64px) + env(safe-area-inset-top, 0px));
  }
}
</style>
